import { Box, BoxProps } from '@hawkins/components';
import styles from './GradientHeader.module.css';

export const GradientHeader = ({ children, ...props }: BoxProps) => {
  return (
    <Box position="relative">
      <Box className={styles.gradientHeader} {...props}>
        {children}
      </Box>
    </Box>
  );
};
